class JenvaraBundleSelector {
  constructor(container) {
    this.container = container;
    this.options = Array.from(
      container.querySelectorAll('[data-jv-bundle-option]')
    );

    this.productInfo = container.closest('product-info');
    this.productPrice = Number(container.dataset.productPrice || 0);

    this.bindEvents();
    this.renderPrices();
    this.selectInitialOption();
  }

  bindEvents() {
    this.options.forEach((option) => {
      option.addEventListener('click', () => {
        this.selectOption(option);
      });

      option.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.selectOption(option);
        }
      });
    });
  }

  getQuantityInput() {
    const scope = this.productInfo || document;

    return scope.querySelector('input[name="quantity"]');
  }

  selectInitialOption() {
    const selectedOption =
      this.container.querySelector(
        '[data-jv-bundle-option].is-selected'
      ) || this.options[0];

    if (selectedOption) {
      this.selectOption(selectedOption);
    }
  }

  selectOption(selectedOption) {
    const quantity = Number(
      selectedOption.dataset.quantity || 1
    );

    this.options.forEach((option) => {
      const isSelected = option === selectedOption;

      option.classList.toggle('is-selected', isSelected);
      option.setAttribute(
        'aria-pressed',
        isSelected ? 'true' : 'false'
      );
    });

    const quantityInput = this.getQuantityInput();

    if (!quantityInput) {
      console.warn(
        'Jenvara bundle selector: Dawn quantity input was not found.'
      );
      return;
    }

    quantityInput.value = quantity;

    quantityInput.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    quantityInput.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

  renderPrices() {
    if (!this.productPrice) return;

    this.options.forEach((option) => {
      const quantity = Number(
        option.dataset.quantity || 1
      );

      const paidQuantity = Number(
        option.dataset.paidQuantity || quantity
      );

      const regularTotal =
        this.productPrice * quantity;

      const discountedTotal =
        this.productPrice * paidQuantity;

      const unitPrice = Math.round(
        discountedTotal / quantity
      );

      const totalElement = option.querySelector(
        '[data-jv-bundle-price]'
      );

      const compareElement = option.querySelector(
        '[data-jv-compare-price]'
      );

      const unitElement = option.querySelector(
        '[data-jv-unit-price]'
      );

      if (totalElement) {
        totalElement.textContent =
          this.formatMoney(discountedTotal);
      }

      if (compareElement) {
        compareElement.textContent =
          paidQuantity < quantity
            ? this.formatMoney(regularTotal)
            : '';
      }

      if (unitElement) {
        unitElement.textContent =
          this.formatMoney(unitPrice);
      }
    });
  }

  formatMoney(cents) {
    const currency =
      window.Shopify?.currency?.active || 'AUD';

    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-AU',
      {
        style: 'currency',
        currency,
      }
    ).format(cents / 100);
  }
}

function initialiseJenvaraBundleSelectors(root = document) {
  root
    .querySelectorAll(
      '[data-jv-bundle-selector]:not([data-jv-initialised])'
    )
    .forEach((container) => {
      container.dataset.jvInitialised = 'true';
      new JenvaraBundleSelector(container);
    });
}

function refreshJenvaraBundleSelectors(root = document) {
  root
    .querySelectorAll('[data-jv-bundle-selector]')
    .forEach((container) => {
      delete container.dataset.jvInitialised;
    });

  initialiseJenvaraBundleSelectors(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initialiseJenvaraBundleSelectors();
  });
} else {
  initialiseJenvaraBundleSelectors();
}

document.addEventListener('shopify:section:load', (event) => {
  initialiseJenvaraBundleSelectors(event.target);
});

document.addEventListener('product-info:loaded', (event) => {
  refreshJenvaraBundleSelectors(event.target);
});